import { NotifyHelper } from "../../../helpers/toast";
import { objGioCongDongDefine } from "../../action-types/gio-cong-dong/IGioCongDongActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const gioCongDongActions = {
    ...generateActions(objGioCongDongDefine, "GIO_CONG_DONG"),
    ...generateActionForKey(objGioCongDongDefine, "GIO_CONG_DONG",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objGioCongDongDefine, "GIO_CONG_DONG",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objGioCongDongDefine, "GIO_CONG_DONG",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objGioCongDongDefine, "GIO_CONG_DONG",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objGioCongDongDefine, "GIO_CONG_DONG",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
